export default "__VITE_ASSET__C$Mb3lP6__"